import { ref } from "vue";

export const LOCALES = {
  en: { title: "English" },
  de: { title: "Deutsch" },
  nl: { title: "Nederlands" },
  es: { title: "Español" },
  da: { title: "Dansk" },
  it: { title: "Italiano" },
  fr: { title: "Français" },
  sv: { title: "Svenska" },
  pt: { title: "Português" },
  zh_Hans: { title: "Chinese (中文)" },
  ko: { title: "Korean (한국인)" },
  ja: { title: "Japanese (日本語)" },
  ar: { title: "Arabic (عربي)" },
};

export const locales = ref(null);

export const getLocale = () => {
  if (localStorage.getItem("AcceptLanguage") !== null) {
    return localStorage.AcceptLanguage;
  } else {
    return "en";
  }
};

export const initLocales = () => {
  locales.value = ["en", "nl", "de", "es", "da", "sv", "it", "fr", "pt", "zh_Hans", "ar", "ja", "ko"];
};
